module.exports = __webpack_public_path__ + "img/sample-img.ed4c8649.webp";